export default __webpack_public_path__ + "static/media/dr-dayson-mbl.e53a085d.png";